import { jsx as _jsx } from "react/jsx-runtime";
import { NodeToolbar } from '@xyflow/react';
import { RFTooltipInner } from './components';
const RFTooltipFC = ({ msg, isVisible, position, offset = 0 }) => {
    return msg ? (_jsx(NodeToolbar, { isVisible: isVisible, position: position, offset: offset, children: _jsx(RFTooltipInner, { msg: msg }) })) : null;
};
export const RFTooltip = RFTooltipFC;
//# sourceMappingURL=RFTooltip.js.map